// extracted by mini-css-extract-plugin
export var bgPositionLight = "styles-module--bgPositionLight--325-p";
export var bgPositionDark = "styles-module--bgPositionDark--x6wsk";
export var lightCheckboxAfter = "styles-module--lightCheckboxAfter--1BQiM";
export var darkCheckboxAfter = "styles-module--darkCheckboxAfter--7Q19T";
export var selectAfter = "styles-module--selectAfter--3Nt8b";
export var selectBefore = "styles-module--selectBefore--Nu9DX";
export var selectBeforeDM = "styles-module--selectBeforeDM--3Rqbn";
export var checkbox = "styles-module--checkbox--16P1h";
export var checkboxDark = "styles-module--checkboxDark--1W_Ss";